var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "order" },
    [
      _c(
        "div",
        { staticClass: "serch-wrap" },
        [
          _c(
            "el-form",
            {
              staticClass: "demo-form-inline",
              attrs: {
                "label-position": "left",
                inline: true,
                model: _vm.orderForm
              }
            },
            [
              _c(
                "el-form-item",
                { attrs: { label: "主订单号" } },
                [
                  _c("el-input", {
                    attrs: { placeholder: "主订单号" },
                    nativeOn: {
                      keyup: function($event) {
                        if (
                          !$event.type.indexOf("key") &&
                          _vm._k(
                            $event.keyCode,
                            "enter",
                            13,
                            $event.key,
                            "Enter"
                          )
                        ) {
                          return null
                        }
                        return _vm.searchOrderList.apply(null, arguments)
                      }
                    },
                    model: {
                      value: _vm.orderForm.main_number,
                      callback: function($$v) {
                        _vm.$set(_vm.orderForm, "main_number", $$v)
                      },
                      expression: "orderForm.main_number"
                    }
                  })
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "el-form-item",
                { attrs: { label: "子订单号" } },
                [
                  _c("el-input", {
                    attrs: { placeholder: "子订单号" },
                    nativeOn: {
                      keyup: function($event) {
                        if (
                          !$event.type.indexOf("key") &&
                          _vm._k(
                            $event.keyCode,
                            "enter",
                            13,
                            $event.key,
                            "Enter"
                          )
                        ) {
                          return null
                        }
                        return _vm.searchOrderList.apply(null, arguments)
                      }
                    },
                    model: {
                      value: _vm.orderForm.order_number,
                      callback: function($$v) {
                        _vm.$set(_vm.orderForm, "order_number", $$v)
                      },
                      expression: "orderForm.order_number"
                    }
                  })
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "el-form-item",
                { attrs: { label: "编号", "label-width": "40px" } },
                [
                  _c("el-input", {
                    model: {
                      value: _vm.orderForm.serialNumber,
                      callback: function($$v) {
                        _vm.$set(_vm.orderForm, "serialNumber", $$v)
                      },
                      expression: "orderForm.serialNumber"
                    }
                  })
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "el-form-item",
                { attrs: { label: "主单状态" } },
                [
                  _c(
                    "el-select",
                    {
                      attrs: { clearable: "", placeholder: "请选择" },
                      model: {
                        value: _vm.orderForm.mainOrderStatus,
                        callback: function($$v) {
                          _vm.$set(_vm.orderForm, "mainOrderStatus", $$v)
                        },
                        expression: "orderForm.mainOrderStatus"
                      }
                    },
                    _vm._l(_vm.mainOrderOptions, function(item) {
                      return _c("el-option", {
                        key: item.value,
                        attrs: { label: item.label, value: item.value }
                      })
                    }),
                    1
                  )
                ],
                1
              ),
              _vm._v(" "),
              _vm.statusActive === 4 && _vm.isZhifaOrFactory
                ? _c(
                    "el-form-item",
                    { attrs: { label: "物流状态" } },
                    [
                      _c(
                        "el-select",
                        {
                          attrs: { clearable: "", placeholder: "请选择" },
                          model: {
                            value: _vm.orderForm.box_status,
                            callback: function($$v) {
                              _vm.$set(_vm.orderForm, "box_status", $$v)
                            },
                            expression: "orderForm.box_status"
                          }
                        },
                        _vm._l(Object.keys(_vm.logStatusOptions), function(
                          item
                        ) {
                          return _c("el-option", {
                            key: item,
                            attrs: {
                              label: _vm.logStatusOptions[item],
                              value: item
                            }
                          })
                        }),
                        1
                      )
                    ],
                    1
                  )
                : _vm._e(),
              _vm._v(" "),
              _vm.syncStatusFlag
                ? _c(
                    "el-form-item",
                    { attrs: { label: "同步状态" } },
                    [
                      _c(
                        "el-select",
                        {
                          attrs: { clearable: "", placeholder: "请选择" },
                          model: {
                            value: _vm.orderForm.syncStatus,
                            callback: function($$v) {
                              _vm.$set(_vm.orderForm, "syncStatus", $$v)
                            },
                            expression: "orderForm.syncStatus"
                          }
                        },
                        _vm._l(_vm.syncOptions, function(item) {
                          return _c("el-option", {
                            key: item.value,
                            attrs: { label: item.label, value: item.value }
                          })
                        }),
                        1
                      )
                    ],
                    1
                  )
                : _vm._e(),
              _vm._v(" "),
              _c(
                "el-form-item",
                { attrs: { label: "推送日期" } },
                [
                  _c(
                    "el-col",
                    { attrs: { span: 11 } },
                    [
                      _c("el-date-picker", {
                        staticStyle: { width: "100%" },
                        attrs: { type: "datetime", placeholder: "开始日期" },
                        model: {
                          value: _vm.orderForm.start_created_at,
                          callback: function($$v) {
                            _vm.$set(_vm.orderForm, "start_created_at", $$v)
                          },
                          expression: "orderForm.start_created_at"
                        }
                      })
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c("el-col", { staticClass: "line", attrs: { span: 2 } }, [
                    _vm._v("-")
                  ]),
                  _vm._v(" "),
                  _c(
                    "el-col",
                    { attrs: { span: 11 } },
                    [
                      _c("el-date-picker", {
                        staticStyle: { width: "100%" },
                        attrs: { type: "datetime", placeholder: "结束日期" },
                        model: {
                          value: _vm.orderForm.end_created_at,
                          callback: function($$v) {
                            _vm.$set(_vm.orderForm, "end_created_at", $$v)
                          },
                          expression: "orderForm.end_created_at"
                        }
                      })
                    ],
                    1
                  )
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "el-form-item",
                {
                  directives: [
                    {
                      name: "show",
                      rawName: "v-show",
                      value: _vm.statusActive === 4 || _vm.statusActive === 3,
                      expression: "statusActive === 4 || statusActive === 3"
                    }
                  ],
                  attrs: { label: "物流联系电话", "label-width": "85px" }
                },
                [
                  _c("el-input", {
                    model: {
                      value: _vm.orderForm.courier_mobile,
                      callback: function($$v) {
                        _vm.$set(_vm.orderForm, "courier_mobile", $$v)
                      },
                      expression: "orderForm.courier_mobile"
                    }
                  })
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "el-form-item",
                { attrs: { label: "报备状态", "label-width": "60px" } },
                [
                  _c(
                    "el-select",
                    {
                      attrs: {
                        placeholder: "选择报备状态",
                        clearable: "",
                        multiple: ""
                      },
                      model: {
                        value: _vm.orderForm.shipping_status,
                        callback: function($$v) {
                          _vm.$set(_vm.orderForm, "shipping_status", $$v)
                        },
                        expression: "orderForm.shipping_status"
                      }
                    },
                    _vm._l(Object.keys(_vm.shipStatusOptions), function(item) {
                      return _c("el-option", {
                        key: item,
                        attrs: {
                          label: _vm.shipStatusOptions[item],
                          value: item
                        }
                      })
                    }),
                    1
                  )
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "div",
                { staticClass: "drop-down-wrap" },
                [
                  _c(
                    "transition",
                    { attrs: { name: "el-fade-in-linear" } },
                    [
                      !_vm.dropStatus
                        ? _c("el-button", {
                            staticStyle: {
                              background: "#fff",
                              border: "none",
                              color: "#666",
                              "font-size": "24px",
                              padding: "0"
                            },
                            attrs: {
                              type: "text",
                              icon: "iconfont icon-xiangxiashuangjiantou"
                            },
                            on: { click: _vm.dropHandler }
                          })
                        : _vm._e(),
                      _vm._v(" "),
                      _vm.dropStatus
                        ? _c("el-button", {
                            staticStyle: {
                              background: "#fff",
                              border: "none",
                              color: "#666",
                              "font-size": "24px",
                              padding: "0"
                            },
                            attrs: {
                              type: "text",
                              icon: "iconfont icon-xiangshangshuangjiantou"
                            },
                            on: { click: _vm.dropHandler }
                          })
                        : _vm._e()
                    ],
                    1
                  )
                ],
                1
              ),
              _vm._v(" "),
              _c("el-collapse-transition", [
                _c(
                  "div",
                  {
                    directives: [
                      {
                        name: "show",
                        rawName: "v-show",
                        value: _vm.dropStatus,
                        expression: "dropStatus"
                      }
                    ]
                  },
                  [
                    _c(
                      "el-form-item",
                      { attrs: { label: "要求发货日" } },
                      [
                        _c(
                          "el-col",
                          { attrs: { span: 11 } },
                          [
                            _c("el-date-picker", {
                              staticStyle: { width: "100%" },
                              attrs: { type: "date", placeholder: "开始日期" },
                              model: {
                                value: _vm.orderForm.start_out_ware_day,
                                callback: function($$v) {
                                  _vm.$set(
                                    _vm.orderForm,
                                    "start_out_ware_day",
                                    $$v
                                  )
                                },
                                expression: "orderForm.start_out_ware_day"
                              }
                            })
                          ],
                          1
                        ),
                        _vm._v(" "),
                        _c(
                          "el-col",
                          { staticClass: "line", attrs: { span: 2 } },
                          [_vm._v("-")]
                        ),
                        _vm._v(" "),
                        _c(
                          "el-col",
                          { attrs: { span: 11 } },
                          [
                            _c("el-date-picker", {
                              staticStyle: { width: "100%" },
                              attrs: { type: "date", placeholder: "结束日期" },
                              model: {
                                value: _vm.orderForm.end_out_ware_day,
                                callback: function($$v) {
                                  _vm.$set(
                                    _vm.orderForm,
                                    "end_out_ware_day",
                                    $$v
                                  )
                                },
                                expression: "orderForm.end_out_ware_day"
                              }
                            })
                          ],
                          1
                        )
                      ],
                      1
                    ),
                    _vm._v(" "),
                    _c(
                      "el-form-item",
                      { attrs: { label: "快递单号" } },
                      [
                        _c("el-input", {
                          model: {
                            value: _vm.orderForm.courierNumber,
                            callback: function($$v) {
                              _vm.$set(_vm.orderForm, "courierNumber", $$v)
                            },
                            expression: "orderForm.courierNumber"
                          }
                        })
                      ],
                      1
                    )
                  ],
                  1
                )
              ]),
              _vm._v(" "),
              _c(
                "el-form-item",
                [
                  _c(
                    "el-button",
                    {
                      attrs: { type: "primary", size: "small" },
                      on: { click: _vm.searchOrderList }
                    },
                    [_vm._v("查询")]
                  )
                ],
                1
              )
            ],
            1
          )
        ],
        1
      ),
      _vm._v(" "),
      _c("div", { staticClass: "tableTitle" }, [
        _c("span", [_vm._v("查询结果：")]),
        _vm._v(" "),
        _c("div", { staticClass: "tableStatus" }, [
          _c("div", [
            _c(
              "div",
              {
                staticClass: "status",
                class: { active: _vm.statusActive === 2 },
                on: {
                  click: function($event) {
                    return _vm.getTableStatus(2)
                  }
                }
              },
              [_c("p", [_vm._v("备货中")])]
            ),
            _vm._v(" "),
            _c(
              "div",
              {
                staticClass: "status",
                class: { active: _vm.statusActive === 3 },
                on: {
                  click: function($event) {
                    return _vm.getTableStatus(3)
                  }
                }
              },
              [_c("p", [_vm._v("已备货")])]
            ),
            _vm._v(" "),
            _c(
              "div",
              {
                staticClass: "status",
                class: { active: _vm.statusActive === 4 },
                on: {
                  click: function($event) {
                    return _vm.getTableStatus(4)
                  }
                }
              },
              [_c("p", [_vm._v("已出库")])]
            ),
            _vm._v(" "),
            _c(
              "div",
              {
                staticClass: "status",
                class: { active: _vm.statusActive === 5 },
                on: {
                  click: function($event) {
                    return _vm.getTableStatus(5)
                  }
                }
              },
              [_c("p", [_vm._v("失效")])]
            )
          ]),
          _vm._v(" "),
          _c(
            "div",
            { staticClass: "btns" },
            [
              _c(
                "el-dropdown",
                {
                  directives: [
                    {
                      name: "show",
                      rawName: "v-show",
                      value: _vm.statusActive === 4 || _vm.statusActive === 3,
                      expression: "statusActive === 4 || statusActive === 3"
                    }
                  ],
                  staticClass: "batchbtn",
                  staticStyle: { "margin-left": "15px" },
                  attrs: {
                    trigger: "click",
                    size: "medium",
                    placement: "bottom"
                  },
                  on: { command: _vm.handleCommand }
                },
                [
                  _c(
                    "el-button",
                    { attrs: { type: "primary", size: "small" } },
                    [_vm._v("\n            录入物流运单\n          ")]
                  ),
                  _vm._v(" "),
                  _c(
                    "el-dropdown-menu",
                    { attrs: { slot: "dropdown" }, slot: "dropdown" },
                    [
                      _c("el-dropdown-item", { attrs: { command: "b" } }, [
                        _vm._v("录入全部")
                      ]),
                      _vm._v(" "),
                      _c("el-dropdown-item", { attrs: { command: "a" } }, [
                        _vm._v("录入勾选")
                      ])
                    ],
                    1
                  )
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "el-button",
                {
                  directives: [
                    {
                      name: "show",
                      rawName: "v-show",
                      value: _vm.statusActive === 1,
                      expression: "statusActive === 1"
                    }
                  ],
                  attrs: { size: "small", type: "primary" },
                  on: { click: _vm.acceptGoods }
                },
                [_vm._v("接单")]
              ),
              _vm._v(" "),
              _c(
                "el-button",
                {
                  directives: [
                    {
                      name: "show",
                      rawName: "v-show",
                      value: _vm.statusActive === 2,
                      expression: "statusActive === 2"
                    }
                  ],
                  staticClass: "blue",
                  attrs: { size: "small", type: "primary" },
                  on: { click: _vm.printStockList }
                },
                [_vm._v("每日备货清单")]
              ),
              _vm._v(" "),
              _c(
                "el-button",
                {
                  directives: [
                    {
                      name: "show",
                      rawName: "v-show",
                      value: _vm.statusActive === 2,
                      expression: "statusActive === 2"
                    }
                  ],
                  attrs: { size: "small", type: "primary" },
                  on: { click: _vm.autoPareDoneHandler }
                },
                [_vm._v("备货完成")]
              ),
              _vm._v(" "),
              _c(
                "el-button",
                {
                  directives: [
                    {
                      name: "show",
                      rawName: "v-show",
                      value: _vm.statusActive === 4,
                      expression: "statusActive === 4"
                    }
                  ],
                  attrs: { size: "small", type: "primary" },
                  on: { click: _vm.completeGoods }
                },
                [_vm._v("订单打包")]
              ),
              _vm._v(" "),
              _c(
                "el-button",
                {
                  directives: [
                    {
                      name: "show",
                      rawName: "v-show",
                      value: _vm.statusActive === 3,
                      expression: "statusActive === 3"
                    }
                  ],
                  attrs: { size: "small", type: "primary" },
                  on: {
                    click: function($event) {
                      return _vm.factoryOutGoods("dialogCancel")
                    }
                  }
                },
                [_vm._v("出库")]
              ),
              _vm._v(" "),
              _c(
                "el-button",
                {
                  directives: [
                    {
                      name: "show",
                      rawName: "v-show",
                      value: _vm.showCancelGoods,
                      expression: "showCancelGoods"
                    }
                  ],
                  attrs: { size: "small", type: "primary" },
                  on: { click: _vm.cancelGoods }
                },
                [_vm._v("取消备货")]
              ),
              _vm._v(" "),
              _c(
                "el-button",
                {
                  directives: [
                    {
                      name: "show",
                      rawName: "v-show",
                      value: _vm.statusActive === 3,
                      expression: "statusActive === 3"
                    }
                  ],
                  attrs: { size: "small", type: "primary" },
                  on: { click: _vm.exportGoodsListHandler }
                },
                [_vm._v("导出货物清单")]
              ),
              _vm._v(" "),
              _vm.isZhifaOrFactory
                ? _c(
                    "el-button",
                    {
                      directives: [
                        {
                          name: "show",
                          rawName: "v-show",
                          value: _vm.statusActive === 3,
                          expression: "statusActive === 3"
                        }
                      ],
                      attrs: { size: "small", type: "primary" },
                      on: { click: _vm.prinPurchaseHandler }
                    },
                    [_vm._v("打印采购订单")]
                  )
                : _vm._e()
            ],
            1
          )
        ])
      ]),
      _vm._v(" "),
      _c("order-table", {
        directives: [
          {
            name: "loading",
            rawName: "v-loading",
            value: _vm.loadOrderTable,
            expression: "loadOrderTable"
          }
        ],
        ref: "orderTable",
        attrs: {
          orderTableData: _vm.orderTableData,
          statusActive: _vm.statusActive
        },
        on: {
          getDetailTable: _vm.getDetailTable,
          getTrackNo: _vm.getTrackNo,
          getBoxData: _vm.getBoxData,
          updateOrder: _vm.getOrderList,
          getSelectOrderData: _vm.getSelectOrderData,
          acceptGoodsOk: _vm.acceptGoodsOk,
          editOrder: _vm.editOrderHandler,
          getTransportDetail: _vm.getTransportDetail,
          getDetailAsyncStatus: _vm.getDetailAsyncStatus
        }
      }),
      _vm._v(" "),
      _c("order-print-table", {
        attrs: { orderTableData: _vm.orderTableData }
      }),
      _vm._v(" "),
      _c("el-pagination", {
        attrs: {
          "current-page": _vm.currentPage,
          "page-sizes": [10, 50, 100, 200],
          "page-size": _vm.pagesize,
          layout: "total, sizes, prev, pager, next, jumper",
          total: _vm.totalCount
        },
        on: {
          "size-change": _vm.handleSizeChange,
          "current-change": _vm.handleCurrentChange,
          "update:pageSize": function($event) {
            _vm.pagesize = $event
          },
          "update:page-size": function($event) {
            _vm.pagesize = $event
          }
        }
      }),
      _vm._v(" "),
      _c(
        "el-tabs",
        {
          attrs: { type: "card" },
          model: {
            value: _vm.activeName,
            callback: function($$v) {
              _vm.activeName = $$v
            },
            expression: "activeName"
          }
        },
        [
          _c(
            "el-tab-pane",
            { attrs: { label: "商品信息", name: "goods_info" } },
            [
              _c("order-detail-table", {
                attrs: { orderDetailTableData: _vm.orderDetailTableData },
                on: { updateOrder: _vm.getOrderList }
              })
            ],
            1
          ),
          _vm._v(" "),
          _vm.statusActive === 4 && _vm.isZhifaOrFactory
            ? _c(
                "el-tab-pane",
                { attrs: { label: "物流轨迹", name: "log_track" } },
                [
                  _c("orderTrack", {
                    attrs: {
                      order_id: _vm.current_row_id,
                      main_number: _vm.current_row_main_number,
                      order_type: "1"
                    }
                  })
                ],
                1
              )
            : _vm._e()
        ],
        1
      ),
      _vm._v(" "),
      _c("order-dialog", {
        ref: "orderDialog",
        attrs: { boxData: _vm.boxData }
      }),
      _vm._v(" "),
      _c("cancel-pare-dialog", {
        ref: "cancelPareDialog",
        on: { cancelOrder: _vm.cancelOrder }
      }),
      _vm._v(" "),
      _vm.showdeliverySheet
        ? _c("delivery-sheet", {
            directives: [
              {
                name: "show",
                rawName: "v-show",
                value: false,
                expression: "false"
              }
            ],
            ref: "deliverySheet",
            attrs: { id: _vm.selectOrderDataId, ids: _vm.selectOrderData }
          })
        : _vm._e(),
      _vm._v(" "),
      _vm.cancelOrderDialog
        ? _c("order-cancel-dialog", {
            attrs: {
              dialog: _vm.cancelOrderDialog,
              table: _vm.cancelDialogTable
            },
            on: {
              cancel: _vm.cancelDialogHandler,
              confirm: _vm.cancelDialogConfirmHandler
            }
          })
        : _vm._e(),
      _vm._v(" "),
      _vm.showTransportDetailDialog
        ? _c("transport-detail-dialog", {
            attrs: {
              dialog: _vm.showTransportDetailDialog,
              row: _vm.TransportDetailDialogRow
            },
            on: {
              cancel: function() {
                return (_vm.showTransportDetailDialog = false)
              }
            }
          })
        : _vm._e(),
      _vm._v(" "),
      _c(
        "el-dialog",
        {
          attrs: {
            visible: _vm.printDialogVisible,
            "append-to-body": true,
            center: "",
            width: "500px"
          },
          on: {
            "update:visible": function($event) {
              _vm.printDialogVisible = $event
            }
          }
        },
        [
          _c(
            "span",
            {
              staticStyle: { color: "#fff" },
              attrs: { slot: "title" },
              slot: "title"
            },
            [_vm._v("确认")]
          ),
          _vm._v(" "),
          _c("p", [
            _vm._v("\n      确认打印"),
            _c("span", { staticClass: "red-color-text" }, [
              _vm._v(_vm._s(_vm.selectOrderData.length))
            ]),
            _vm._v("个订单，共"),
            _c("span", { staticClass: "red-color-text" }, [
              _vm._v(_vm._s(_vm.printBoxNumTotal))
            ]),
            _vm._v("个打包箱数？\n    ")
          ]),
          _vm._v(" "),
          _c(
            "span",
            {
              staticClass: "dialog-footer",
              attrs: { slot: "footer" },
              slot: "footer"
            },
            [
              _c(
                "el-button",
                {
                  attrs: { size: "mini" },
                  on: {
                    click: function($event) {
                      _vm.printDialogVisible = false
                    }
                  }
                },
                [_vm._v("取 消")]
              ),
              _vm._v(" "),
              _c(
                "el-button",
                {
                  attrs: { type: "primary", size: "mini" },
                  on: {
                    click: function($event) {
                      return _vm.print(true)
                    }
                  }
                },
                [_vm._v("确 定")]
              )
            ],
            1
          )
        ]
      ),
      _vm._v(" "),
      _c(
        "el-dialog",
        {
          attrs: {
            visible: _vm.notice,
            "append-to-body": true,
            top: "25vh",
            center: "",
            width: "580px"
          },
          on: {
            "update:visible": function($event) {
              _vm.notice = $event
            }
          }
        },
        [
          _c(
            "span",
            {
              staticStyle: { color: "#fff", "font-size": "16px" },
              attrs: { slot: "title" },
              slot: "title"
            },
            [_vm._v("关于调整店铺管理系统箱码打印方式的通知")]
          ),
          _vm._v(" "),
          _c("p", { staticStyle: { "font-size": "16px" } }, [
            _vm._v(
              "\n      店铺管理系统的箱码打印方式调整，变更为浏览器打印。打印操作说明详见\n      "
            ),
            _c("a", { staticClass: "notice", on: { click: _vm.goNotice } }, [
              _vm._v("【公告中心】-【打印指导】。")
            ])
          ]),
          _vm._v(" "),
          _c("p", { staticStyle: { "font-size": "16px" } }, [
            _vm._v("调整生效时间：2019年9月5日20:00点。")
          ]),
          _vm._v(" "),
          _c(
            "p",
            { staticStyle: { "text-align": "right", "font-weight": "600" } },
            [_vm._v("锐锢商城")]
          ),
          _vm._v(" "),
          _c(
            "p",
            { staticStyle: { "text-align": "right", "font-weight": "600" } },
            [_vm._v("2019年9月5日")]
          )
        ]
      ),
      _vm._v(" "),
      _c(
        "el-dialog",
        {
          attrs: {
            visible: _vm.outGoodsDialog,
            "append-to-body": true,
            top: "25vh",
            center: "",
            width: "580px"
          },
          on: {
            "update:visible": function($event) {
              _vm.outGoodsDialog = $event
            }
          }
        },
        [
          _c(
            "span",
            {
              staticStyle: { color: "#fff", "font-size": "16px" },
              attrs: { slot: "title" },
              slot: "title"
            },
            [_vm._v("出库确认")]
          ),
          _vm._v(" "),
          _c("p", [_vm._v("请确认是否出库")]),
          _vm._v(" "),
          _c("p", { staticStyle: { color: "red", "font-weight": "bold" } }, [
            _vm._v("一旦出库，则订单无法再更改状态")
          ]),
          _vm._v(" "),
          _c(
            "div",
            {
              staticClass: "dialog-footer",
              attrs: { slot: "footer" },
              slot: "footer"
            },
            [
              _c(
                "el-button",
                {
                  attrs: { size: "mini" },
                  on: {
                    click: function($event) {
                      _vm.outGoodsDialog = false
                    }
                  }
                },
                [_vm._v("取 消")]
              ),
              _vm._v(" "),
              _c(
                "el-button",
                {
                  attrs: { type: "primary", size: "mini" },
                  on: {
                    click: function($event) {
                      return _vm.factoryOutGoods("sureOut")
                    }
                  }
                },
                [_vm._v("确 定")]
              )
            ],
            1
          )
        ]
      ),
      _vm._v(" "),
      _c("boxcode", {
        directives: [
          { name: "show", rawName: "v-show", value: false, expression: "false" }
        ],
        ref: "boxcode"
      }),
      _vm._v(" "),
      _c(
        "el-dialog",
        {
          attrs: {
            visible: _vm.orderSyncDialogVisible,
            "append-to-body": true,
            title: "对接详情",
            width: "580px"
          },
          on: {
            "update:visible": function($event) {
              _vm.orderSyncDialogVisible = $event
            }
          }
        },
        [
          _c("p", [
            _c("span", [_vm._v("批次号：")]),
            _c("span", [_vm._v(_vm._s(_vm.orderSyncInfo.main_number))])
          ]),
          _vm._v(" "),
          _c("p", [
            _c("span", [_vm._v("同步时间：")]),
            _c("span", [_vm._v(_vm._s(_vm.orderSyncInfo.async_create_time))])
          ])
        ]
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-564e3951", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-564e3951","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/pages/bigorder/order.vue
// module id = null
// module chunks = 